var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTool7(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3054_8175)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.32667 6.74391C7.01961 4.05097 11.1711 3.44168 13.9814 3.37344C15.7691 3.33004 17.1686 4.72958 17.1252 6.51728C17.057 9.32754 16.4477 13.4791 13.7548 16.172C10.8082 19.1186 6.11524 19.5705 3.34393 19.5486C2.00281 19.538 0.960622 18.4959 0.950026 17.1547C0.92813 14.3834 1.38006 9.69052 4.32667 6.74391Z",
    fill: "#B9D6DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.16699 16.3354C9.69942 10.8029 12.8012 7.70113 18.3337 2.1687",
    stroke: "#8CBBC8",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.01953 7.70166L13.0005 7.26588",
    stroke: "#62A1B3",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.8418 11.5168L8.99261 11.1537",
    stroke: "#62A1B3",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8008 12.4819L13.2366 7.50096",
    stroke: "#62A1B3",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.98535 15.6604L9.3485 11.5096",
    stroke: "#62A1B3",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3054_8175"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0 0.501953)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTool7);
export default __webpack_public_path__ + "static/media/tool_7.a00834aec29705b0fcf8dfbb1931539a.svg";
export { ForwardRef as ReactComponent };